import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/filials";
import validateForm from "../../lib/helpers/validateForm";
import { getDateFormat } from "../../lib/helpers/dates";

// UI
import {
  Alerts,
  Box,
  Button,
  Input,
  Row,
  Col,
  ButtonGroup,
  Header,
  HeaderPage
} from "../../ui";

class FilialEditPage extends Component {
  state = {
    titleHeader: `${
      this.props.match.params.id ? "Изменение" : "Создание"
    } филиала`,
    filial: {},
    form: {
      name: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.name
      },
      city: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.city
      },
      work_days: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.work_days
      },
      cash_desk_start_day: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.cash_desk_start_day
      },
      cash_desk: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.cash_desk
      },
      count_fine_days: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.count_fine_days
      },
      percent_fine: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.percent_fine
      },
      sum_fine_bilet_out: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum_fine_bilet_out
      }
    },
    saveDisabled: false
  };

  async componentDidMount() {
    const filialId = this.props.match.params.id;

    // Edit or Create
    if (filialId) {
      const filial = await API.filials.getOne(filialId);

      if (filial) {
        const { form } = this.state;

        // Заполняем форму
        for (let key in form) {
          if (form[key].isNumber) {
            form[key].value = String(filial[key]) || "0";
          } else if (form[key].isDate) {
            form[key].value = getDateFormat(filial[key]);
          } else {
            form[key].value = filial[key] || "";
          }
        }

        this.setState({ filial, form });
      }
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      // Отключаем кнопку
      this.setState({ saveDisabled: true, loading: true });

      const { form } = this.state;
      const filialId = this.props.match.params.id;
      const optionsRequest = {};

      // Если изменение, только изменённые поля
      if (filialId) {
        for (let nameItem in form) {
          if (form[nameItem].isEdited) {
            optionsRequest[nameItem] = form[nameItem].value;
          }
        }
      } else {
        // Иначе все поля
        for (let nameItem in form) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Edit or Create
        if (filialId) {
          // Изменение текущего
          const resultUpdated = await API.filials.editOne(filialId, {
            ...optionsRequest
          });

          if (resultUpdated) {
            Alerts.success("Филиал изменён");

            // Включаем кнопку, данные сохранились
            this.setState({
              saveDisabled: false,
              loading: false
            });

            this.props.history.goBack();
          } else {
            Alerts.error("Филиал не изменён");

            // Включаем кнопку, данные не сохранились
            this.setState({
              saveDisabled: false,
              loading: false
            });
          }
        } else {
          // Создание нового
          const resultCreated = await API.filials.createOne({
            ...optionsRequest
          });

          if (resultCreated) {
            Alerts.success("Создан новый филиал");

            // Включаем кнопку, данные сохранились
            this.setState({
              saveDisabled: false,
              loading: false
            });

            this.props.history.goBack();
          } else {
            Alerts.error("Филиал не создан");

            // Включаем кнопку, данные не сохранились
            this.setState({
              saveDisabled: false,
              loading: false
            });
          }
        }
      } else {
        Alerts.alert("В филиале нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState({ saveDisabled: false, loading: false });

        this.props.history.goBack();
      }
    }
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.saveDisabled}
              >
                {this.props.match.params.id ? "Сохранить" : "Создать"}
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Box>
            <Header size={2} margin="no-top">
              Информация
            </Header>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Input
                  label="Название:"
                  name="name"
                  value={this.state.form.name.value}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Местоположение:"
                  name="city"
                  value={this.state.form.city.value}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Рабочие дни:"
                  name="work_days"
                  value={this.state.form.work_days.value}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Касса
                </Header>

                <Input
                  label="Начало дня:"
                  type="number"
                  name="cash_desk_start_day"
                  value={this.state.form.cash_desk_start_day.value}
                  errors={this.state.form.cash_desk_start_day.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Конец дня:"
                  type="number"
                  name="cash_desk"
                  value={this.state.form.cash_desk.value}
                  errors={this.state.form.cash_desk.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Количество
                </Header>

                <Input
                  label="Залоговых билетов:"
                  value={this.state.filial.count_bilets}
                  disabled={true}
                />
                <Input
                  label="Приходных ордеров:"
                  value={this.state.filial.count_blanks_add}
                  disabled={true}
                />
                <Input
                  label="Расходных ордеров:"
                  value={this.state.filial.count_blanks_remove}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Прочее
                </Header>

                <Input
                  label="Количество дней штрафа:"
                  type="number"
                  name="count_fine_days"
                  value={this.state.form.count_fine_days.value}
                  errors={this.state.form.count_fine_days.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Процент штрафа за задержку:"
                  type="number"
                  name="percent_fine"
                  value={this.state.form.percent_fine.value}
                  errors={this.state.form.percent_fine.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Штраф за потерю билета:"
                  type="number"
                  name="sum_fine_bilet_out"
                  value={this.state.form.sum_fine_bilet_out.value}
                  errors={this.state.form.sum_fine_bilet_out.errors}
                  handleChange={this.handleInput}
                />
              </Col>
            </Row>
          </Box>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(FilialEditPage));
